import { FileAddOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Modal, Row, Spin, Upload, message } from 'antd';
import { FC, useState } from 'react';
import { useFormContext } from '../../Context/DeclarationContext';
import { uploadFiles } from '../../Services/declarations';
import RutTools from '../../helpers/format-rut';
import { FILE_UPLOAD_GENERAL_ERROR, FILE_UPLOAD_LARGE_ERROR } from '../../utils/generals';
import './attachNewAditionalDocument.scss';

type AttachNewAditionalDocumentProps = {
  openModal: boolean;
  titleModal: string;
  indexDOCA: number;
  closeModal: () => void;
  updateIndexDOCA: () => void;
};

const AttachNewAditionalDocument: FC<AttachNewAditionalDocumentProps> = ({ openModal, titleModal, closeModal, indexDOCA, updateIndexDOCA }) => {
  const { state, dispatch } = useFormContext();
  const [loadingFile, setLoadingFile] = useState(false);
  const [fileList, setFileList] = useState<any[]>([]);
  const [viewUploadBtn, setViewUploadBtn] = useState(false);
  const [nonmbreFile, setNombreFile] = useState('');

  const handleDoneFile = () => {
    console.log('handleDoneFile', fileList);

    const document = [...(state?.state_document || [])];

    if (fileList.length > 0) {
      const index = fileList[0].indexDocument;
      document[index].filename = fileList[0].name;
      document[index].url = fileList[0].url;
      document[index].status = 'done';
      document[index].isActive = true;
      document[index].nombreTitulo = fileList[0].nombreTitulo;

      dispatch({
        type: 'UPDATE_STATE_DOCUMENT',
        payload: [...document],
      });

      setViewUploadBtn(false);
      setNombreFile('');
      setFileList([]);
      updateIndexDOCA();
      closeModal();
    }
  };

  const handleCancelClose = () => {
    console.log('handleCancelClose');

    setFileList([]);
    setViewUploadBtn(false);
    setNombreFile('');
    closeModal();
  };

  return (
    <Modal open={openModal} title={titleModal} footer={null} onCancel={handleCancelClose} width={500} maskClosable={false}>
      <div className="modalOne">
        <p>
          Agregue el documento y asegúrese que toda la información este correcta.{' '}
          <small>(Ingrese el nombre del documento y el documento para poder continuar. )</small>
        </p>

        <div>
          <div>
            <Form.Item label="Nombre">
              <Input placeholder={'Nombre del adjunto'} value={nonmbreFile} onChange={(e) => setNombreFile(e.target.value)} />
              {nonmbreFile.length > 1 && nonmbreFile.length > 25 ? <span style={{ color: 'red' }}>Debe tener máximo 25 caracteres</span> : null}
            </Form.Item>
          </div>
          <div>
            <Spin spinning={loadingFile} size="small">
              <Upload
                name="avatar"
                customRequest={() => { }}
                listType="picture"
                fileList={fileList?.length ? [...fileList] : []}
                maxCount={1}
                onChange={async (info) => {
                  const r = info.file;
                  console.log('File info samo', r);
                  if (info.file.status === 'removed') {
                    message.success('Documento eliminado correctamente');
                    setFileList([]);
                    setViewUploadBtn(false);
                  }

                  try {
                    if (info.file !== undefined && info.file.status !== 'removed') {
                      info.file.name = `${state.vehiclePatente?.deviceId}_${RutTools.formatWithoutDots(state?.declarant?.customerIdentityNumber || ('' as string))}`;

                      setLoadingFile(true);
                      const response = await uploadFiles(
                        info.file.originFileObj,
                        `DOCA${indexDOCA}`,
                        `${state.vehiclePatente?.deviceId}_${RutTools.formatWithoutDots(state.declarant?.customerIdentityNumber || ('' as string))}`
                      );

                      info.file.status = 'done';
                      const index = state.state_document?.findIndex((item: any) => item.documentType.includes('DOCA') && item.isActive === false);

                      if (index && index !== -1) {
                        setFileList([
                          {
                            name: response.data[0].filename,
                            url: response.data[0].url,
                            isActive: true,
                            status: 'done',
                            nombreTitulo: `${nonmbreFile}.${response.data[0].filename.split('.')[1]}`,
                            indexDocument: index,
                          },
                        ]);
                        setViewUploadBtn(true);
                        message.success('Documento subido correctamente');
                      }
                    }
                  } catch (error) {
                    const g = error as any;
                    if (g?.status === 413) {
                      message.error(FILE_UPLOAD_LARGE_ERROR);
                    } else {
                      message.error(FILE_UPLOAD_GENERAL_ERROR);
                    }
                    setFileList([]);
                    setViewUploadBtn(false);
                  } finally {
                    setLoadingFile(false);
                  }
                }}
              >
                <div className="upload_file">
                  <FileAddOutlined style={{ fontSize: '45px' }} />
                  <div>Agregar Archivo</div>
                </div>
              </Upload>
            </Spin>
          </div>
          <div>
            <Row className="controls" gutter={20}>
              <Col span={12}>
                <Button className="btn_calcel" onClick={handleCancelClose}>
                  Cancelar
                </Button>
              </Col>
              <Col span={12}>
                {viewUploadBtn && nonmbreFile.length > 0 && nonmbreFile.length <= 25 && (
                  <Button className="btn_confirm" onClick={handleDoneFile}>
                    Cargar documento
                  </Button>
                )}
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AttachNewAditionalDocument;
